import settings from '../../services/settings'

const state = {
  messages: [],
  socket: null,
  personType: null,
  isConversationStarted: false,
  wsStatus: 'finished',
  isLimitExceeded: false
}
const mutations = {
  updateMessages (state, messages) {
    state.messages = messages
  },
  setMessages (state, messages) {
    state.messages.push(messages)
  },
  resetMessages (state) {
    state.messages = []
  },
  setPersonType (state, personType) {
    state.personType = personType
  },
  startConversation (state) {
    state.isConversationStarted = true
  },
  setIsLimitExceeded (state, limit) {
    state.isLimitExceeded = limit
  },
  setWsStatus (state, status) {
    state.wsStatus = status
  }
}
const getters = {
  getMessages (state) {
    return state.messages
  },
  getPersonType (state) {
    return state.personType
  },
  getConversationState (state) {
    return state.isConversationStarted
  },
  getIsLimitExceeded (state) {
    return state.isLimitExceeded
  },
  getWsStatus (state, status) {
    return state.wsStatus
  }
}
const actions = {
  sendMessage ({ commit, state }, question) {
    return new Promise((resolve, reject) => {
      const uuid = Math.random().toString(16).slice(2)
      const token = localStorage.getItem('accessToken')
      const locationId = localStorage.getItem('locationId')

      commit('startConversation')
      commit('setMessages', {
        question,
        answer: '',
        id: uuid
      })

      commit('setWsStatus', 'starting')

      if (this.socket === undefined) {
        this.socket = new WebSocket(`wss://izbus-core.aica.chat/api/v1/qa/ws-chat/?loc_id=${locationId || 0}`)

        this.socket.onopen = () => {
          this.socket.send(JSON.stringify({ token }))
          if (question === null) {
            return
          }
          this.socket.send(JSON.stringify({ question }))
        }
      } else {
        this.socket.send(JSON.stringify({ question }))
      }

      this.socket.onmessage = (e) => {
        const response = JSON.parse(e.data)
        const messages = JSON.parse(JSON.stringify(state.messages))
        const findResponse = messages.findIndex(response => response.id === uuid)
        messages[findResponse].answer += response.piece ? response.piece : ''
        messages[findResponse].state = response.state

        commit('setWsStatus', response.state)
        commit('updateMessages', messages)
      }
    })
  },
  setPersonType ({ commit }, personType) {
    commit('setPersonType', personType)
  },
  welcomeMessage ({ commit, state, rootState }) {
    if (state.messages.length) {
      return
    }
    commit('setMessages', {
      question: '',
      answer: settings.translations.welcome.replace('{name}', rootState.auth.userName)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
